import { useEffect, useState } from "react";
import "./LoadingScreen.css";

export default function LoadingScreen() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // simulacija učitavanja (zamijeni s pravim loading stateom)
    const timer = setTimeout(() => {
      setVisible(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <div className="logo-wrapper">
          <img
            src="/logo.png"
            alt="Logo"
            className="logo"
          />
          <div className="spinner"></div>
        </div>

        <p className="loading-text">Učitavanje...</p>
      </div>
    </div>
  );
}